import React, { useState } from 'react';
import { OverlayTrigger, Popover, Button } from 'react-bootstrap';
import Icon from '../../../icons/Icon';

const ConfirmationPopover = ({ 
    children, 
    onConfirm, 
    onCancel, 
    title = "Confirm Action", 
    message = "Are you sure you want to proceed?", 
    confirmText = "Yes", 
    cancelText = "No",
    confirmVariant = "danger",
    cancelVariant = "secondary",
    placement = "top",
    className = ""
}) => {
    const [show, setShow] = useState(false);

    const handleConfirm = () => {
        setShow(false);
        if (onConfirm) {
            onConfirm();
        }
    };

    const handleCancel = () => {
        setShow(false);
        if (onCancel) {
            onCancel();
        }
    };

    const popover = (
        <Popover id="confirmation-popover" className="confirmation-popover">
            <Popover.Header className="d-flex align-items-center justify-content-between">
                <span className="fw-bold">{title}</span>
                <button 
                    type="button" 
                    className="btn-close btn-close-sm" 
                    onClick={handleCancel}
                    aria-label="Close"
                ></button>
            </Popover.Header>
            <Popover.Body>
                <p className="mb-3">{message}</p>
                <div className="d-flex gap-2 justify-content-end">
                    {/* <Button 
                        variant={cancelVariant} 
                        size="sm" 
                        onClick={handleCancel}
                    >
                        {cancelText}
                    </Button> */}
                    <Button 
                        variant={confirmVariant} 
                        size="sm" 
                        onClick={handleConfirm}
                    >
                        {confirmText}
                    </Button>
                </div>
            </Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger
            trigger="click"
            placement={placement}
            show={show}
            onToggle={setShow}
            overlay={popover}
            rootClose
        >
            {children}
        </OverlayTrigger>
    );
};

export default ConfirmationPopover;
